import './style.scss';
import "@fancyapps/ui/dist/fancybox.css";

import imagesLoaded from 'imagesloaded';
import InfiniteScroll from 'infinite-scroll';

import Cookies from 'js-cookie'
import { Fancybox } from "@fancyapps/ui";

import Masonry from 'masonry-layout';
import Carousel from 'bootstrap/js/dist/carousel';
import Collapse from 'bootstrap/js/dist/collapse';
import Dropdown from 'bootstrap/js/dist/dropdown';
import Modal from 'bootstrap/js/dist/modal';
import Tab from 'bootstrap/js/dist/tab';

import daterangepicker from 'bootstrap-daterangepicker';

import Inputmask from "inputmask";

import $ from 'jquery';
import validate from 'jquery-validation';
import select2 from 'select2';
import jinplace from './assets/jinplace';

import { Html5QrcodeScanner } from "html5-qrcode";
import { Html5Qrcode } from "html5-qrcode";

const generateOverlay = (target = false) => {
	let rng = Math.floor((Math.random() * 1000) + 1);
	let style = {
		'background-color': 'rgba(255,255,255,0.5)',
		'width': '100%',
		'height': '100%',
		'position': 'absolute',
		'top': '0px',
		'left': '0px',
		'zIndex': '100',
		'opacity': '1',
		'display': 'flex',
		'align-items': 'center',
		'justify-content': 'center',
		'isolation': 'isolate',
		'z-index': '999999'
	};
	let wrapper = target;

	if (target == false) {
		wrapper = $('body');
		style.position = 'fixed';
		style.width = '100vw';
		style.height = '100vh';
	}

	wrapper.css('position', 'relative');
	let overlay = $('<div />')
		.css(style)
		.attr('id', `overlay_${rng}`)
		.hide();
	overlay.append(
		$('<div />', {
			'class': 'sk-chase',
			'style': 'z-index: 1;'
		}).append(
			$('<div />', { 'class': 'sk-chase-dot' })
		).append(
			$('<div />', { 'class': 'sk-chase-dot' })
		).append(
			$('<div />', { 'class': 'sk-chase-dot' })
		).append(
			$('<div />', { 'class': 'sk-chase-dot' })
		).append(
			$('<div />', { 'class': 'sk-chase-dot' })
		).append(
			$('<div />', { 'class': 'sk-chase-dot' })
		)
	);
	wrapper.append(overlay);

	return overlay;
}

const isSet = (variable) => {
	return (typeof variable != 'undefined' && variable !== null) ? true : false;
}

const clearSelect = (target) => {
	target.querySelectorAll('option').forEach(option => option.remove())
}
const genUUID = (len = 16) => {
	return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
		var r = Math.random() * len | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
		return v.toString(len);
	});
}

// calculate payout price
const attachCalculatorEvent = () => {
	const itemPriceInputs = [].slice.call(document.querySelectorAll('[data-payout]'));
	if (itemPriceInputs) {
		if (itemPriceInputs.length) {
			itemPriceInputs.forEach(input => {
				input.addEventListener('change', function () {

					let payoutInput = document.getElementById(this.dataset.target);

					if (payoutInput) {
						let price = this.value;
						let payout = 0;

						if (price > 0) {
							payout = price * (this.dataset.payout / 100);
						}
						payoutInput.value = payout;
					}
				});
			})
		}
	}
}

jQuery(function ($) {
	$('.editable').each(function () {
		let el = $(this);
		let classes = 'form-control form-control-sm';
		if (el.data('classes')) {
			classes += ` ${el.data('classes')}`;
		}

		el.jinplace({
			inputClass: classes
		}).on('jinplace:update', function (evt, element, data, opts) {
			if (opts.attribute == 'price') {
				$(element.data('update')).text('updating...');
				$.ajax({
					dataType: "text",
					headers: { 'Cache-Control': 'no-cache' },
					url: opts.loadurl,
					data: {
						object: opts.object,
						attribute: 'payout'
					}
				}).done(function (response) {
					$(element.data('update')).text(response);
				});
			}

		});
	})

	$(document).on('click', '.close-dropdown', function (e) {
		e.preventDefault();

		let el = $(this).parents('.dropdown').find('.dropdown-toggle');
		Dropdown.getInstance(el).toggle();
	});
	$(document).on('click', '.notification', function (e) {
		e.preventDefault();

		let el = $(this);
		let li = el.parents('.dropdown-item');
		let list = el.parents('.notifications');

		if (['h4', 'p'].includes(e.target.nodeName.toLowerCase())) {
			$(this).removeClass('unread');

			$.ajax({
				dataType: "json",
				url: list.data('url'),
				data: {
					id: li.data('id'),
					action: 'notification-touch'
				}
			}).done(function (response) {
				if (typeof response.new != 'undefined') {
					if (response.new <= 0) {
						$('span#new-notifications').addClass('d-none');
					}
					$('span#new-notifications').html(response.new);
				}
			});
		}
	});

	$(document).on('click', '.delete-notification', function (e) {
		e.preventDefault();

		let el = $(this);
		let li = el.parents('.dropdown-item');
		let list = el.parents('.notifications');

		if (li) {
			li.fadeOut(function () {
				li.remove();
				if (list.children('li').length < 1) {
					list.append($('<li />', {
						'class': 'no-notification dropdown-item text-center',
					}).text('No notifications'));
				}
				$.ajax({
					dataType: "json",
					url: list.data('url'),
					data: {
						id: el.data('id'),
						action: 'notification-delete'
					}
				}).done(function (response) {
					if (typeof response.new != 'undefined') {
						if (response.new <= 0) {
							$('span#new-notifications').addClass('d-none');
						}
						$('span#new-notifications').html(response.new);
					}
				});
			})
		}
	});
	$(document).on('click', '.delete-notification-modal', function (e) {
		let el = $(this);
		let btn = $(`.delete-notification[data-id="${el.data('id')}"]`);
		if (btn.length) {
			btn.trigger('click');
		}
	});

	$(document).on('click', 'a.show-item-history', function (evt) {
		evt.preventDefault();

		let el = $(this);
		Fancybox.show([{
			src: el.attr('href'),
			type: 'ajax',
		}], {
			showCloseButton: false,
			mainClass: 'fancy-alertbox',
		});
	});

	$('form.show-loader').on('submit', function (evt) {
		let el = $(this);
		let overlay = generateOverlay(el);

		overlay.fadeIn();

		let validator = el.validate({
			errorElement: 'small',
			errorClass: 'is-invalid text-danger mt-1 text-uppercase fw-bold',
			validClass: 'is-valid',
			errorPlacement: function (error, element) {
				element.after(error);
			},
			highlight: function (element, errorClass, validClass) {
				$(element).addClass(errorClass).removeClass(validClass);
			},
			unhighlight: function (element, errorClass, validClass) {
				$(element).removeClass(errorClass).addClass(validClass);
			},
			invalidHandler: function (form, validator) {
				if (!validator.numberOfInvalids()) { return; }

				$('html, body').animate({
					scrollTop: $(validator.errorList[0].element).offset().top - $(validator.errorList[0].element).parent('div').height()
				}, 800);
			}
		});
		validator.form();

		if (!el.valid()) {
			overlay.fadeOut(function () {
				overlay.remove();
			});
			return false;
		}
	});

	$('a.show-overlay').on('click', function (evt) {
		let el = $(this);
		let target = false;
		if (el.data('target')) {
			target = $(`#${el.data('target')}`);
		}
		let overlay = generateOverlay(target);
		overlay.fadeIn();
	});

	$('.delete-item-image').on('click', function (evt) {
		evt.preventDefault();
		let el = $(this);
		let parent = $(`#${el.data('parent')}`);

		if (confirm('Are you sure you want to delete this image?')) {
			let overlay = generateOverlay(parent);
			overlay.fadeIn();
			$.ajax({
				dataType: "json",
				url: el.attr('href'),
				data: {
					id: el.data('id'),
					action: 'delete-image'
				}
			}).done(function (response) {
				if (response.status == 1) {
					parent.remove();

					const masonryWrapper = document.querySelector(`.masonry`);
					if (masonryWrapper) {
						let msnry = Masonry.data(masonryWrapper);
						msnry.layout();
					}
				} else {
					let err = (typeof response.message != 'undefined') ? response.message : 'Unable to process request';

					Fancybox.show([{
						src: `<div id="fancy-alertbox" class="message bg-danger"><h4>Error</h4><p>${err}</p></div>`,
						type: 'html',
					}], {
						showCloseButton: false,
						mainClass: 'fancy-alertbox',
					});
				}

				overlay.remove();
			}).fail(function (jqxhr, textStatus, error) {
				Fancybox.show([{
					src: `<div id="fancy-alertbox" class="message bg-danger"><h4>Error</h4><p>${textStatus} ${error}</p></div>`,
					type: 'html',
				}], {
					showCloseButton: false,
					mainClass: 'fancy-alertbox',
				});
				overlay.remove();
			});
		}
		return false;
	});

	$('.conditional-input').each(function () {
		let el = $(this);
		//let target = $(`#${el.data('target')}`);

		if (el.data('target')) {
			let valueTrigger = el.data('showon') ? el.data('showon').trim().toLowerCase() : '';
			let targets = el.data('target').split(',');
			targets.forEach(target => {
				let el = $(target.trim());
				el.hide();
			});

			el.on('change', function (evt) {
				let input = $(this);
				if (evt.target.type == 'checkbox' || evt.target.type == 'radio') {
					let isChecked = input.is(":checked");

					if (isChecked && input.val().toLowerCase() == valueTrigger) {
						targets.forEach(target => {
							let el = $(target.trim());
							el.fadeIn();
						});
					} else {
						targets.forEach(target => {
							let el = $(target.trim());
							el.hide();
							el.find('input').val('');
						});
					}
				} else {
					if (evt.target.tagName.toLowerCase() == 'select') {
						if (input.find(":selected").length) {
							if (input.find(":selected").val().toLowerCase() == valueTrigger) {
								targets.forEach(target => {
									let el = $(target.trim());
									el.fadeIn();
								});
							} else {
								targets.forEach(target => {
									let el = $(target.trim());
									el.hide();
									el.find('input').val('');
								});
							}
						}
					}
				}
			}).trigger('change');
		}
	});

	$('.btn-open-file').on('click', function (evt) {
		evt.preventDefault();
		let el = $(this);
		if (el.data('target')) {
			$(`#${el.data('target')}`).trigger('click');
		}
	});
	$('.btn-clear-file').on('click', function (evt) {
		evt.preventDefault();
		let el = $(this);
		if (el.data('target')) {
			let target = $(`#${el.data('target')}`);
			target.val('');

			target.parent().append(target.clone(true));
			target.remove();
			$(`#${el.data('preview')}`).empty();
		}
	});

	$('.btn-slide-toggle').on('click', function (evt) {
		evt.preventDefault();
		let el = $(this);

		$(el.data('target')).slideToggle();
	}).trigger('click');

	$('input.image-preview').on('change', function () {
		let el = $(this);
		let files = el.get(0).files;
		let preview = $(`#${el.data('target')}`);
		let uploadForm = $(`form#${el.data('form')}`);

		preview.empty();
		if (files.length) {
			$.each(files, function (i, file) {
				let reader = new FileReader();

				reader.onload = function (event) {
					let div = $('<div />', {
						'class': 'd-flex align-items-center p-2 mb-2 bg-light'
					});
					div.append($('<img />', {
						'src': event.target.result,
						'class': 'img-fluid',
						'style': 'width:25%;'
					}));
					div.append($('<span />', {
						'class': 'px-3'
					}).text(file.name));
					preview.append(div);
				}
				reader.readAsDataURL(file);
			});
		}
	});

	$('select.select2').select2({
		theme: "bootstrap-5",
		templateResult: function (state) {
			if (!state.id) {
				return state.text;
			}
			let optImage = $(state.element).data('image');
			if (!optImage) {
				return state.text;
			} else {
				return $(`<span><img src="${optImage}" class="img-fluid" width="23px" /> ${state.text}</span>`);
			}
		}
	});

	$('.select2-remote').each(function () {
		let el = $(this);
		el.select2({
			theme: "bootstrap-5",
			allowClear: true,
			multiple: true,
			maximumSelectionSize: 1,
			minimumInputLength: 2,
			//placeholder: "Start typing",
			ajax: {
				url: el.data('endpoint'),
				delay: 250,
				processResults: function (data) {
					return {
						results: data.items
					};
				},
				cache: true
			},
			templateResult: function (state) {
				if (state.loading) return "Searching...";

				let label = state.text;

				if (typeof state.sku != 'undefined') {
					label += ` - ${state.sku}`;
				}
				if (!state.id) {
					return label;
				}

				if (!state.image) {
					return label;
				} else {
					return $(`<span><img src="${state.image}" class="img-fluid" width="32px" /> ${label}</span>`);
				}
			}
		}).on('select2:select', function (e) {
			let data = e.params.data;
			$('input[name="item_name"]').val(data.text);
			$('input[name="item_sku"]').val(data.sku);
			el.val(null).trigger('change');
		});
	});

	$('#confirm-code-form').on('submit', function (evt) {
		evt.preventDefault();
		let form = $(this);

		let overlay = generateOverlay($('body'));
		overlay.fadeIn();
		$.ajax({
			dataType: 'json',
			url: form.attr('action'),
			data: form.serialize()
		}).done(function (response) {
			let alertClass = (response.status == 1) ? 'bg-success' : 'bg-danger';
			let alertHeading = (response.status == 1) ? 'Success' : 'Error';
			Fancybox.show([{
				src: `<div id="fancy-alertbox" class="message ${alertClass}"><h4>${alertHeading}</h4><p>${response.message}</p></div>`,
				type: 'html',
			}], {
				showCloseButton: false,
				mainClass: 'fancy-alertbox',
			});
			overlay.remove();
		}).fail(function (jqxhr, textStatus, error) {
			Fancybox.show([{
				src: `<div id="fancy-alertbox" class="message bg-danger"><h4>Error</h4><p>${textStatus} : ${error}</p></div>`,
				type: 'html',
			}], {
				showCloseButton: false,
				mainClass: 'fancy-alertbox',
			});
			overlay.remove();
		});
	});

	$('#shopifyOrderLookupClearForm').on('click', function (evt) {
		evt.preventDefault();
		let form = $('#shopifyOrderLookupForm');
		let input = form.find('input[name="q"]');
		input.val('');
		$('#shopifyOrderLookupBody').empty();
	});

	$('#shopifyOrderLookupForm').on('submit', function (evt) {
		evt.preventDefault();
		let el = $(this);

		let input = el.find('input[name="q"]');
		let query = input.val().trim();
		let wrapper = $('#shopifyOrderLookupBody');

		if (query != '') {
			let overlay = generateOverlay($('#shopifyOrderLookupWrapper'));
			overlay.fadeIn();
			$.ajax({
				dataType: 'json',
				url: el.data('url'),
				data: {
					action: 'shopify-order-lookup',
					q: query,
				}
			}).done(function (response) {
				overlay.remove();
				wrapper.empty();

				if (response.status == 0) {
					wrapper.html(`<div class="alert alert-warning text-center">${response.message}</div>`);
				} else {
					let tableWrapper = $('<div />', {
						'class': 'table-responsive'
					});
					let table = $('<table />', {
						'class': 'table table-hover'
					});

					let thead = $('<thead />');
					let trh = $('<tr />');
					trh.append($('<th />', { 'class': 'text-center' }).html('Location'));
					trh.append($('<th />', { 'class': 'text-center' }).html('Order #'));
					trh.append($('<th />', { 'class': 'text-center' }).html('Timestamp'));
					trh.append($('<th />', { 'class': 'text-center' }).html('Status'));
					trh.append($('<th />', { 'class': 'text-center' }).html('Subtotal'));
					thead.append(trh);

					let tbody = $('<tbody />');
					table.append(tbody);
					table.append(thead);

					response.orders.forEach(order => {
						let tr = $('<tr />');
						tr.append($('<td />', {
							'class': 'text-center',
						}).text(order.location));
						tr.append($('<td />', {
							'class': 'text-center',
						}).text(order.order_number));
						tr.append($('<td />', {
							'class': 'text-center',
						}).text(order.created_at));
						tr.append($('<td />', {
							'class': 'text-center',
						}).text(order.status));
						tr.append($('<td />', {
							'class': 'text-center',
						}).text(order.subtotal));
						tbody.append(tr);


						let tr2 = $('<tr />');
						let tableWrapperInner = $('<div />', {
							'class': 'table-responsive'
						});
						let tableRow = $('<table />', {
							'class': 'table table-dark table-sm table-striped caption-top'
						});
						let theadRow = $('<thead />');
						let trh = $('<tr />');
						trh.append($('<th />', { 'class': 'text-left' }).html('Item Name'));
						trh.append($('<th />', { 'class': 'text-center' }).html('SKU'));
						trh.append($('<th />', { 'class': 'text-center' }).html('QTY'));
						trh.append($('<th />', { 'class': 'text-center' }).html('Price'));
						theadRow.append(trh);
						tableRow.append(theadRow);

						let tbodyRow = $('<tbody />');
						tableRow.append(tbodyRow);

						order.items.forEach(item => {
							let tr = $('<tr />');
							tr.append($('<td />', {
								'class': 'text-left',
							}).text(item.name));
							tr.append($('<td />', {
								'class': 'text-center',
							}).text(item.sku));
							tr.append($('<td />', {
								'class': 'text-center',
							}).text(item.quantity));
							tr.append($('<td />', {
								'class': 'text-center',
							}).text(item.price));
							tableRow.append(tr);
						});

						tableWrapperInner.append(tableRow);
						tr2.append($('<td />', {
							'colspan': '5',
						}).append(tableWrapperInner));

						tbody.append(tr2);
					});
					tableWrapper.append(table);
					wrapper.append(tableWrapper);
				}
			});
		}
	});

	const updateRowHighlight = (el) => {
		let selected = el.find(':selected');
		let row = el.closest('tr');

		row.removeClass(function (index, className) {
			return (className.match(new RegExp("\\S*row-highlight-\\S*", 'g')) || []).join(' ')
		});
		row.addClass(`row-highlight-${selected.val()}`);
		el.attr('class', `row-highlight-picker ${selected.val()}`);
	};
	$('.row-highlight-picker').each(function () {
		let el = $(this);

		updateRowHighlight(el);
		el.on('change', function (evt) {
			let table = el.closest('div.table-responsive');
			let overlay = generateOverlay(table);
			overlay.fadeIn();

			$.ajax({
				url: el.data('url'),
				data: {
					action: 'inline-edit',
					attribute: 'highlight',
					object: el.data('id'),
					value: el.val()
				}
			}).done(function (response) {
				overlay.remove();
				updateRowHighlight(el);
			});
		});
	});

	$('input.date-range').daterangepicker({
		timePicker: false,
		autoUpdateInput: false,
		locale: {
			format: 'MMM DD YYYY'
		}
	}).on("apply.daterangepicker", function (e, picker) {
		let el = picker.element;
		el.val(picker.startDate.format(picker.locale.format) + ' - ' + picker.endDate.format(picker.locale.format));

		if (el.hasClass('submit-on-change')) {
			el.closest('form').trigger('submit');
		}
	}).css('cursor', 'pointer');

	$('.submit-on-change').on('change', function () {
		let el = $(this);
		el.closest('form').trigger('submit');
	});

	$('input.datepicker').daterangepicker({
		singleDatePicker: true,
		timePicker: false,
		autoApply: true,
		autoUpdateInput: false,
		locale: {
			format: 'MMM DD YYYY'
		}
	}).on("apply.daterangepicker", function (e, picker) {
		picker.element.val(picker.startDate.format(picker.locale.format));
	}).css('cursor', 'pointer');

	$('select.item-status-select').on('change', function (evt) {
		let targets = ['#mark-as-paid-wrapper', '#transaction_id_wrapper', '#return_item_wrapper'];
		let el = $(this);
		targets.forEach(target => {
			let el = $(target.trim());
			el.hide();
		});
		let selectedValue = el.find(":selected").val().toLowerCase();

		switch (selectedValue) {
			case 'sold': {
				$('#mark-as-paid-wrapper, #transaction_id_wrapper').fadeIn();
				break;
			}
			case 'returned': {
				$('#return_item_wrapper').fadeIn();
				break;
			}
		}
	}).trigger('change');

	$('.btn-clear').on('click', function (evt) {
		evt.preventDefault();
		let target = $(this).data('target');
		$(target).val('');
	})

	$('input.checkbox-toggle-all').on('change', function () {
		let state = $(this).prop('checked');
		$('input.checkbox-toggle').each(function () {
			$(this).prop('checked', state); //check 
		});
	});

	$('#btn-add-item-row').on('click', function (evt) {
		evt.preventDefault();

		let el = $(this);
		let target = $(`#${el.data('target')}`);
		let row = target.find('tr:first-child').clone();
		let payoutId = null;
		let fields = {
			'payout': null,
			'price': null
		}


		row.find('input').each(function () {
			let el = $(this);
			let elId = `${el.data('name')}-${genUUID()}`;
			el.attr('id', elId);
			el.val('');

			if (Object.keys(fields).includes(el.data('name'))) {
				Inputmask().mask(el);
				fields[el.data('name')] = elId;
				el.val(0);
			}
			if (['quantity'].includes(el.data('name'))) {
				el.val(1);
			}
			if (['item_sku'].includes(el.data('name'))) {
				el.val('NA');
			}
		});
		row.find(`#${fields['price']}`).attr('data-target', fields['payout']);
		target.append(row);
		attachCalculatorEvent();
	});

	$('select[name="payment_location"]').each(function () {
		let el = $(this);
		el.on('change', function () {
			let select = $(this);
			let input = $(`#${select.data('id')}`);
			if (select.val() == 'other') {
				input.removeClass('d-none');
			} else {
				input.addClass('d-none');
			}
		}).trigger('change');
	});

	$(document).on('click', 'a.btn-delete-row', function (evt) {
		evt.preventDefault();

		let el = $(this);
		let row = el.parent().parent();
		let rows = $(`#items-tables tr`).length;

		if (rows > 1) {
			row.remove();
		}
	});
	$(document).on('click', '.btn-save-payout', function (evt) {
		evt.preventDefault();

		let el = $(this);
		let id = el.data('id');
		let target = $(el.data('target'));
		let overlay = generateOverlay(target);

		overlay.show();
		$.ajax({
			dataType: "json",
			url: `${el.data('url')}backend/ajax.php`,
			data: {
				date_settled: target.find('input[name="date_settled"]').val(),
				payment_type: target.find('select[name="payment_type"] option:selected').val(),
				payment_reference: target.find('input[name="payment_reference"]').val(),
				payment_location: target.find('select[name="payment_location"] option:selected').val(),
				payment_location_other: target.find('input[name="payment_location_other"]').val(),
				id: el.data('id'),
				action: 'update-payout'
			}
		}).done(function (response) {
			let alertClass = (response.status == 1) ? 'bg-success' : 'bg-danger';
			let alertHeading = (response.status == 1) ? 'Success' : 'Error';
			Fancybox.show([{
				src: `<div id="fancy-alertbox" class="message ${alertClass}"><h4>${alertHeading}</h4><p>${response.message}</p></div>`,
				type: 'html',
			}], {
				showCloseButton: false,
				mainClass: 'fancy-alertbox',
			});
			overlay.remove();
		}).fail(function (jqxhr, textStatus, error) {
			Fancybox.show([{
				src: `<div id="fancy-alertbox" class="message bg-danger"><h4>Error</h4><p>${textStatus} : ${error}</p></div>`,
				type: 'html',
			}], {
				showCloseButton: false,
				mainClass: 'fancy-alertbox',
			});
			overlay.remove();
		});
	});

	$(document).on('keypress', 'input.numbers-only', function (e) {
		// Allow: backspace, delete, tab, escape, enter and .
		if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 110, 190]) !== -1 ||
			// Allow: Ctrl+A
			(e.keyCode == 65 && e.ctrlKey === true) ||
			// Allow: Ctrl+C
			(e.keyCode == 67 && e.ctrlKey === true) ||
			// Allow: Ctrl+X
			(e.keyCode == 88 && e.ctrlKey === true) ||
			// Allow: home, end, left, right
			(e.keyCode >= 35 && e.keyCode <= 39)) {
			// let it happen, don't do anything
			return;
		}

		//var allowedChars = new RegExp("^[0-9\-\.]+$");
		var allowedChars = new RegExp("^[0-9\.]+$");
		var str = String.fromCharCode(!e.charCode ? e.which : e.charCode);
		if (allowedChars.test(str)) {
			return true;
		}
		e.preventDefault();
		return false;
	});
	$(document).on('keyup', 'input.numbers-only', function (e) {
		// the addition, which whill check the value after a keyup (triggered by Ctrl+V)
		// We take the same regex as for allowedChars, but we add ^ after the first bracket : it means "all character BUT these"
		//var forbiddenChars = new RegExp("[^0-9\-\.]", 'g');
		var forbiddenChars = new RegExp("[^0-9\.]", 'g');
		if (forbiddenChars.test($(this).val())) {
			var str = $(this).val();
			str = str.replace(/[\s]/g, '-');
			str = str.replace(forbiddenChars, '');

			$(this).val(str);
		}
	});
});
window.addEventListener("load", function () {
	Inputmask().mask(document.querySelectorAll("input"));

	attachCalculatorEvent();

	InfiniteScroll.imagesLoaded = imagesLoaded;

	const masonryLayouts = [].slice.call(document.querySelectorAll('.masonry'));
	if (masonryLayouts.length) {
		masonryLayouts.forEach(grid => {
			let msnry = new Masonry(grid, {
				itemSelector: '.grid__item', // select none at first
				stagger: 30,
				// nicer reveal transition
				visibleStyle: { transform: 'translateY(0)', opacity: 1 },
				hiddenStyle: { transform: 'translateY(100px)', opacity: 0 },
				percentPosition: true
			});

			if (grid.hasAttribute('data-infinitescroll')) {
				//create and append loader animation
				let loader = document.createElement("div");
				loader.classList.add('infinite-scroll-status');
				for (let i = 1; i <= 4; i++) {
					let span = document.createElement("span");
					loader.appendChild(span);
				}
				grid.parentNode.insertBefore(loader, grid.nextSibling);

				let infScroll = new InfiniteScroll(grid, {
					path: '.pagination__next',
					append: '.grid__item',
					scrollThreshold: false,
					button: '.pagination__load',
					outlayer: msnry,
					history: false,
					prefill: true,
					status: '.infinite-scroll-status'
				});
				//make sure we have proper layout on initial load
				infScroll.on('append', function (body, path, items, response) {
					msnry.layout();
				});
				//make sure we hide hte loader and button on the last page
				infScroll.on('last', function (body, path) {
					document.querySelector('.infinite-scroll-status').style.display = 'none';
					document.querySelector('.pagination__load').style.display = 'none';
				});
			}
		});
	}

	//set active nav links
	const queryPaths = window.location.pathname
		.split('/')
		.map(name => {
			return name.toLowerCase()
		}).filter(n => n);
	const navLinks = [].slice.call(document.querySelectorAll('#main-nav a'));
	let hasActiveLink = false;
	if (navLinks.length) {
		navLinks.forEach(link => {
			link.classList.remove('active');
			if (link.hasAttribute('data-target')) {
				if (queryPaths.includes(link.getAttribute('data-target').toLowerCase())) {
					link.classList.add('active');
					hasActiveLink = true;
				}
			}
		});
		// if (!hasActiveLink) {
		// 	const homeLink = document.querySelector('#main-nav a[data-target="home"]');
		// 	if (homeLink) {
		// 		hasActiveLink = true;
		// 		homeLink.classList.add('active');
		// 	}
		// }
	}

	// toggle password buttons

	const togglePasswordLinks = [].slice.call(document.querySelectorAll('.btn-toggle-password'));
	if (togglePasswordLinks) {
		if (togglePasswordLinks.length) {
			togglePasswordLinks.forEach(a => {
				a.addEventListener('click', function (evt) {
					let el = evt.target;
					let input = document.getElementById(el.dataset.target);
					let type = input.getAttribute("type") === "password" ? "text" : "password";

					input.setAttribute("type", type);
					el.classList.toggle('fa-eye');
					el.classList.toggle('fa-eye-slash');
				});
			})
		}
	}
	// confirm links
	const confirmLinks = [].slice.call(document.querySelectorAll('.confirm'));
	if (confirmLinks) {
		if (confirmLinks.length) {
			confirmLinks.forEach(a => {
				a.addEventListener('click', function (evt) {
					let message = (typeof a.dataset.message != 'undefined') ? a.dataset.message : "Are you sure you want to proceed?";
					if (!confirm(message)) {
						evt.stopPropagation();
						evt.preventDefault();
						return false;
					}
				});
			})
		}
	}

	//update/load tabs from url hash
	let hasActiveTab = false;
	let url = location.href.replace(/\/$/, '');
	if (location.hash) {
		const hash = url.split('#');
		const currentTab = document.querySelector(`.nav-link[data-bs-target="#${hash[1]}"]`);

		if (currentTab) {
			const curTab = new Tab(currentTab);
			curTab.show();
			url = location.href.replace(/\/#/, '#');
			history.replaceState(null, null, url);
			hasActiveTab = true;
			setTimeout(() => {
				window.scrollTop = 0;
			}, 400);
		}
	}

	// change url based on selected tab
	const selectableTabList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tab"]'));
	if (selectableTabList.length) {
		selectableTabList.forEach((selectableTab) => {
			if (selectableTab.classList.contains('active')) {
				hasActiveTab = true;
			}
			selectableTab.addEventListener('click', function () {
				const hash = selectableTab.getAttribute('data-bs-target');
				history.replaceState(null, null, url.split('#')[0] + hash);
			});
		});
		if (!hasActiveTab) {
			selectableTabList[0].dispatchEvent(new Event('click'));
		}
	}

	// address form stuff
	const statesLists = [].slice.call(document.querySelectorAll('select.state-select'));
	if (statesLists.length) {
		statesLists.forEach((statesList) => {
			statesList.addEventListener('change', function () {
				const cityList = document.querySelector(this.getAttribute('data-target'));
				if (cityList) {
					clearSelect(cityList);
					cityList.add(new Option(
						'Loading...',
						''
					));
					fetch(`${this.getAttribute('data-endpoint')}?action=get-cities&parent_id=${this.options[this.selectedIndex].getAttribute('data-id')}`, {
						headers: {
							"Content-Type": "application/json; charset=utf-8"
						}
					})
						.then(res => res.json()) // parse response as JSON (can be res.text() for plain response)
						.then(response => {
							if (response.status == 1) {
								clearSelect(cityList);

								response.data.forEach((obj, index) => {
									let option = document.createElement("option");
									option.value = obj.name;
									option.text = obj.name;
									option.setAttribute('data-id', obj.id)
									cityList.appendChild(option);
								});
							} else {
								clearSelect(cityList);
								cityList.add(new Option(
									'No results',
									''
								));
							}
							cityList.dispatchEvent(new Event('change'));
						})
						.catch(err => {
							clearSelect(cityList);
							cityList.add(new Option(
								'No results',
								''
							));
						});
				}
			});
		});
	}

	// camera
	const cameraModalWindow = document.getElementById('camera-modal');
	const cameraList = document.getElementById('camera-list');
	const cameraSelectBtn = document.getElementById('camera-select-btn');
	const scanBtn = document.getElementById('show-camera-btn');

	let html5QrCode = new Html5Qrcode("camera-reader", {
		experimentalFeatures: {
			useBarCodeDetectorIfSupported: true
		},
		//rememberLastUsedCamera: true
	});

	const barcodeLookupBtn = document.getElementById('barcode-lookup-btn');
	const barcodeLookupInput = document.getElementById('barcord-input');

	const cameraWrapper = document.getElementById('camera-wrapper');
	const lookupResuultsWrapper = document.getElementById('barcode-lookup-results');

	try {
		html5QrCode.stop();
	} catch (error) {
	}

	scanBtn.addEventListener('click', (event) => {
		event.preventDefault();
		scanBtn.classList.add('d-none');
		cameraWrapper.classList.remove('d-none');
		cameraSelectBtn.dispatchEvent(new Event('click'));
		lookupResuultsWrapper.innerHTML = '';
		barcodeLookupInput.value = '';
	});

	barcodeLookupBtn.addEventListener('click', (event) => {
		event.preventDefault();

		let code = barcodeLookupInput.value.trim();

		if (code.length) {
			let modalBody = $('#camera-modal-body');
			let overlay = generateOverlay(modalBody);
			let cameraWrapper = $('#camera-wrapper');
			let showScanBtn = $('#show-camera-btn');
			let lookupBody = $('#barcode-lookup-results');
			overlay.show();

			cameraWrapper.addClass('d-none');
			showScanBtn.removeClass('d-none');

			lookupBody.empty();
			lookupBody.append($('<div />', {
				'class': 'text-center px-4 py-3'
			}).html('loading...'));

			$.ajax({
				dataType: "json",
				url: `${modalBody.data('url')}ajax.php`,
				data: {
					code: code,
					action: 'barcode-lookup'
				}
			}).done(function (response) {
				lookupBody.empty();
				if (response.status == 1) {

					let table = $('<table />', {
						'class': 'table'
					});
					let tbody = $('<tbody />',);
					let fields = [
						{
							'key': 'brand',
							'label': 'Brand',
						},
						{
							'key': 'title',
							'label': 'Title',
						},
						{
							'key': 'style_code',
							'label': 'Style Code',
						},
					]


					response.items.forEach(item => {
						let tr = $('<tr />');
						tr.append($('<td />', {
							'rowspan': '2',
							'width': '30%'
						}).html(`<a href="${$('#camera-modal-body').data('url')}consignments/add/${item.id}"><img src="${item.image_file}" class="img-fluid mt-3" /></a>`));
						tr.append($('<td />', {
							'class': 'text-uppercase fw-bold'
						}).html(`<a href="${$('#camera-modal-body').data('url')}consignments/add/${item.id}">${item.title}</a>`));
						tbody.append(tr);

						let item_size = (item.size.length) ? `(<i>size: ${item.size}</i>)` : ``;
						let tr2 = $('<tr />');
						tr2.append($('<td />', {
							'class': 'text-uppercase'
						}).html(`<a href="${$('#camera-modal-body').data('url')}consignments/add/${item.id}">${item.brand} : ${item.style_code} ${item_size}</a>`));

						tbody.append(tr2);
					});

					table.append(tbody);

					lookupBody.append(table);
				} else {
					lookupBody.append($('<div />', {
						'class': 'text-center px-4 py-3'
					}).html(response.message));
				}
				overlay.remove();
			}).fail(function (jqxhr, textStatus, error) {
				lookupBody.empty();
				Fancybox.show([{
					src: `<div id="fancy-alertbox" class="message bg-danger"><h4>Error</h4><p>${textStatus} ${error}</p></div>`,
					type: 'html',
				}], {
					showCloseButton: false,
					mainClass: 'fancy-alertbox',
				});
				overlay.remove();
			});
		} else {
			Fancybox.show([{
				src: `<div id="fancy-alertbox" class="message bg-danger"><h4>Error</h4><p>No barcode specified</p></div>`,
				type: 'html',
			}], {
				showCloseButton: false,
				mainClass: 'fancy-alertbox',
				parentEl: cameraModalWindow
			});
		}
	});

	cameraSelectBtn.style.display = 'none';
	cameraList.addEventListener('change', (event) => {
		cameraSelectBtn.dispatchEvent(new Event('click'));
	});

	cameraSelectBtn.addEventListener('click', (event) => {
		event.preventDefault();
		let cameraId = cameraList.options[cameraList.selectedIndex].value;
		if (cameraId != '') {
			try {
				html5QrCode.stop();
			} catch (error) {
			}

			html5QrCode.start(
				cameraId,
				{
					fps: 10,    // Optional, frame per seconds for qr code scanning
					qrbox: {
						width: 350,
						height: 200
					}  // Optional, if you want bounded box UI
				},
				(decodedText, decodedResult) => {
					barcodeLookupInput.value = decodedText;
					barcodeLookupBtn.dispatchEvent(new Event('click'));
					try {
						html5QrCode.stop();
					} catch (error) {
					}
				},
				(errorMessage) => {
					// parse error, ignore it.
					//console.log(errorMessage)
				})
				.catch((err) => {
					Fancybox.show([{
						src: `<div id="fancy-alertbox" class="message bg-danger"><h4>Error</h4><p>Unabled to start selected camera</p></div>`,
						type: 'html',
					}], {
						showCloseButton: false,
						mainClass: 'fancy-alertbox',
						parentEl: cameraModalWindow
					});
				});
		}
	});
	cameraModalWindow.addEventListener('hidden.bs.modal', function (event) {
		try {
			html5QrCode.stop();
		} catch (error) {
		}
	});
	cameraModalWindow.addEventListener('shown.bs.modal', function (event) {
		let modalBody = $('#camera-modal-body');
		let overlay = generateOverlay(modalBody);
		overlay.show();

		Html5Qrcode.getCameras().then(devices => {
			clearSelect(cameraList);

			if (devices && devices.length) {
				devices.forEach(device => {
					let option = document.createElement("option");
					option.value = device.id;
					option.text = device.label;
					cameraList.appendChild(option);
				});
				overlay.remove();
				cameraSelectBtn.dispatchEvent(new Event('click'));
			} else {
				overlay.remove();
				Fancybox.show([{
					src: `<div id="fancy-alertbox" class="message bg-danger"><h4>Error</h4><p>No cameras available</p></div>`,
					type: 'html',
				}], {
					showCloseButton: false,
					mainClass: 'fancy-alertbox',
					parentEl: cameraModalWindow
				});
			}
		}).catch(err => {
			overlay.remove();
			Fancybox.show([{
				src: `<div id="fancy-alertbox" class="message bg-danger"><h4>Error</h4><p>Unable to access device camera</p></div>`,
				type: 'html',
			}], {
				showCloseButton: false,
				mainClass: 'fancy-alertbox',
				parentEl: cameraModalWindow
			});
		});
	});

	const closeFancybox = [].slice.call(document.querySelectorAll('.close-fancybox'));
	if (closeFancybox.length) {
		closeFancybox.forEach((el) => {
			el.addEventListener('click', function (evt) {
				evt.preventDefault();
				Fancybox.close();
			});
		});
	}
	// notice popup
	const noticeModal = document.getElementById('notice-modal');

	if (noticeModal) {
		if (!Cookies.get('notice_20221121')) {
			Fancybox.show([{
				src: `#notice-modal`,
				type: 'inline',
			}], {
				closeButton: '',
				infinite: false,
				dragToClose: false,
				keyboard: false,
				click: function () {

				},
				on: {
					done: (fancybox, slide) => {
						Cookies.set('notice_20221121', 'true')
					},
				},
			});
		}
	}
});